<div>
  <!-- Action Buttons -->
  <div style="margin-bottom: 10px; text-align: right;">
    <button (click)="print()" class="noPrint" mat-raised-button color="primary">Print</button>
    <button class="noPrint" (click)="exportExcel('dispatchwise_report')" mat-raised-button color="primary">Export</button>
    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>

  <!-- Report Table -->
  <div class="container" id="print-section">
    <table class="table">
      <thead>
        <tr>
          <th colspan="7">Dispatch Vitaran Report</th>
        </tr>
        <tr>
          <th>Sr. No</th>
          <th>Issue Seller Name</th>
          <th>Taluka</th>
          <th>District</th>
          <th>Representative</th>
          <th>Copies</th>
          <th>Delivery <br>Sub Mode</th>
        </tr>
      </thead>
<tbody>
  <ng-container *ngFor="let item of sellerData; let i = index">
    <tr>
      <td>{{ i + 1 }}</td>
      <td>{{ item.issue_seller_id }}</td>
      <td>{{ item.taluka }}</td>
      <td>{{ item.district }}</td>
      <td>{{ item.representative_id }}</td>
      <td>{{ item.issue_copies }}</td>
      <td>{{ item.delevery_sub_mode_id }}</td>
    </tr>
  </ng-container>

  <!-- Total Row -->
  <tr >
    <td colspan="5" style="text-align: right;font-size: 20px; font-weight: bold; color: red;">Total Copies</td>
    <td style="font-size: 20px; font-weight: bold;">{{ totalCopies }}</td>
    <td></td>
  </tr>
</tbody>

      
    </table>
  </div>
</div>

<!-- Loader -->
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>
